import React, {useState} from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import {Button} from 'react-bootstrap'
import {QNAService} from '../../../../services'
import {JSONToHTMLTable} from '../../../../components'
import {Template} from "./Template";

const RepairQuestions = ({ ticket, templates, onSave }) => {
  const [output, _setOutPut] = useState([])
  const onUpdate = (templateId, data) => {
    for (let i = 0; i < output.length; i++) {
      if (output[i].templateId === templateId) {
        _setOutPut([
          ...output.slice(0, i),
          { templateId: templateId, trees: data },
          ...output.slice(i + 1),
        ])
        return
      }
    }
    _setOutPut([...output, { templateId: templateId, trees: data }])
  }
  const saveQnA = () => {
    new QNAService()
      .makePostRequest({
        ticket: ticket.url,
        data: output,
      })
      .then((res) => {
        onSave(res)
      })
  }
  return (
    <ReactBootstrap.Card className="mt-5">
      <ReactBootstrap.Card.Title className="card-header bg-dark text-white card-header">
        Repair Questions
      </ReactBootstrap.Card.Title>
      <ReactBootstrap.Card.Body>
        {templates &&
          templates.map((template) => {
            return (
              <Template
                key={template.templateId}
                templateId={template.templateId}
                trees={template.trees}
                onUpdate={onUpdate}
              />
            )
          })}
        <ReactBootstrap.Col
          className={'text-end'}
          onClick={() => {
            saveQnA()
          }}
          style={{
            marginTop: '1rem',
          }}
          pl={6}
        >
          <Button variant="dark">Save</Button>
        </ReactBootstrap.Col>
          <hr />
        <h1>OutPut</h1>
        <JSONToHTMLTable data={output} />
        <hr />
        <h1>Input</h1>
        <JSONToHTMLTable data={templates} />
      </ReactBootstrap.Card.Body>
    </ReactBootstrap.Card>
  )
}

export default RepairQuestions
